<template>
	<div class="notifications">{{count}}</div>
</template>

<script>
	export default {
		props: {
			count:{
				type: Number,
				required: true
			}
		}
	};
</script>

<style lang="scss" scoped>
	.notifications{
		display: block;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		border: 1px solid $white;
		color: $white;
		background: $red;
		font-size: 14px;
		font-weight: bold;
		line-height: 24px;
		text-align: center;
		position: absolute;
		top: -5px;
		right: -5px;
	}
</style>
